import React, { useRef, useState } from "react";
import Banner from "@/components/Banner";
import ScrollToTop from "@/components/ScrollTop";
import { Form } from "@unform/web";
import * as Yup from "yup";
import Input from "@/components/Input";
import InputMask from "@/components/InputMask";
import { validateCpf, equalTo } from "@/utils/validations";
import InputSelectDinamic from "@/components/InputSelectDinamic";
import ModalPopup from "@/components/ModalPopup";
import { api } from "@/services/api";

import "bootstrap/dist/css/bootstrap-grid.min.css";
import { LabelContainer, Container } from "./styles";

export const Contact = () => {
	const formRef = useRef(null);
	const [load, setLoad] = useState(false);
	const [modalPopup, setModalPopup] = useState(false);
	const [modalContent, setModalContent] = useState({
		title: "",
		content: "",
	});

	async function handleSubmit(data, { reset }) {
		Yup.addMethod(Yup.string, "equalTo", equalTo);
		Yup.addMethod(Yup.string, "validateCpf", validateCpf);

		try {
			// esquema de validacao
			const schema = Yup.object().shape({
				firstname: Yup.string().required("Campo obrigatório"),
				lastname: Yup.string().required("Campo obrigatório"),
				email: Yup.string()
					.email("E-mail inválido")
					.required("Campo obrigatório"),
				emailConfirm: Yup.string()
					.email("E-mail inválido")
					.equalTo(Yup.ref("email"), "E-mails não correspondem")
					.required("Campo obrigatório"),
				cpf: Yup.string()
					.validateCpf("CPF inválido")
					.required("Campo obrigatório"),
				subject: Yup.string().required("Campo obrigatório"),
				message: Yup.string().required("Campo obrigatório"),
				type: Yup.string().required("Campo obrigatório"),
			});

			await schema.validate(data, {
				abortEarly: false,
			});

			formRef.current.setErrors({});
			handleContact(data, reset);
		} catch (err) {
			if (err instanceof Yup.ValidationError) {
				const errorMessages = {};

				err.inner.forEach((error) => {
					errorMessages[error.path] = error.message;
				});

				formRef.current.setErrors(errorMessages);
			}
		}
	}

	function clearForm() {
		formRef.current.setFieldValue( 'cpf', "" );
		formRef.current.setFieldValue( 'email', "" );
		formRef.current.setFieldValue( 'emailConfirm', "" );
		formRef.current.setFieldValue( 'firstname', "" );
		formRef.current.setFieldValue( 'lastname', "" );
		formRef.current.setFieldValue( 'message', "" );
		formRef.current.setFieldValue( 'subject', "" );
		formRef.current.setFieldValue( 'type', "" );
	}

	function handleContact(data) {
		setLoad(true);
		api.post("service/contact", data)
			.then((res) => {
				if (res.data.status === 200) {
					setModalContent({
						title: "Programa Fidelidade GERIOOX",
						content: res.data.message,
					});
					clearForm();
				}
			})
			.catch((error) => {
				console.warn({ endPoint: "service/contact", error });
				setModalContent({
					title: "Programa Fidelidade GERIOOX",
					content: "Ops! Não foi possível atender sua solicitação.",
				});
			})
			.finally(() => {
				setLoad(false);
				setModalPopup(true);
			});
	}

	return (
		<React.Fragment>
			<ScrollToTop />
			<ModalPopup
				visible={modalPopup}
				message={modalContent}
				onClick={() => setModalPopup(false)}
			/>
			<Container>
				<Banner
					text='Contato'
					img={require("@/assets/img/foto2@3x.png").default}
				/>

				<section className='container'>
					<div className='row justify-content-lg-center'>
						<div className='col-12 col-lg-8'>
							<div className='contact'>
								<h2 className='title'>
									Formulário de <span>contato</span>
								</h2>
								<p>
									Esperamos sua mensagem para poder ajudá-lo.
									Complete o formulário com sua mensagem e
									entraremos em contato.
								</p>

								<Form ref={formRef} onSubmit={handleSubmit}>
									<LabelContainer>
										<Input
											label='Nome*'
											name='firstname'
											placeholder='Digite seu nome'
										/>
									</LabelContainer>
									<LabelContainer>
										<Input
											label='Sobrenome*'
											name='lastname'
											placeholder='Digite seu Sobrenome'
										/>
									</LabelContainer>
									<LabelContainer>
										<InputMask
											mask='999.999.999-99'
											label='CPF*'
											name='cpf'
											placeholder='000.000.000-00'
										/>
									</LabelContainer>
									<LabelContainer>
										<Input
											label='E-mail*'
											name='email'
											placeholder='exemplo@exemplo.com'
										/>
									</LabelContainer>
									<LabelContainer>
										<Input
											label='Confirme seu e-mail*'
											name='emailConfirm'
											placeholder='exemplo@exemplo.com'
										/>
									</LabelContainer>
									<LabelContainer>
										<InputSelectDinamic
											label='Sou*'
											name='type'
											data={[
												{
													id: "Dono de pet",
													name: "Dono de pet",
												},
												{
													id: "Médico veterinário",
													name: "Médico veterinário",
												},
												{
													id: "Lojista",
													name: "Lojista",
												},
												{
													id: "Outros",
													name: "Outros",
												},
											]}
										/>
									</LabelContainer>
									<LabelContainer>
										<Input
											label='Assunto*'
											name='subject'
											placeholder='Assunto'
										/>
									</LabelContainer>
									<LabelContainer>
										<Input
											label='Mensagem*'
											name='message'
											placeholder='Digite aqui sua mensagem'
										/>
									</LabelContainer>

									<p className='lengend'>
										* Campos obrigatórios.
									</p>
									<button
										disabled={load ? "disabled" : ""}
										className='btn-primary submit-form'>
										{load ? "enviado" : "enviar"}
									</button>
								</Form>
							</div>
						</div>
					</div>
				</section>
			</Container>
		</React.Fragment>
	);
};

export default Contact;
